import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ayvwhzhr3m: FaireBrandEntity = {
  token: "b_ayvwhzhr3m",
  type: "brand",
  name: "Grandpa Joe's Candy Shop",
  avatarUrl:
    "https://cdn.faire.com/fastly/50a5736cc70cbee8c5a8c2bd1101da50df519e2a105e2740a20cee18465e2b63.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/274172fdd9f1df420ffde54e7a0b6a23e0b154a6aa3cf25457f4eb2cb5809806.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/50a5736cc70cbee8c5a8c2bd1101da50df519e2a105e2740a20cee18465e2b63.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/274172fdd9f1df420ffde54e7a0b6a23e0b154a6aa3cf25457f4eb2cb5809806.jpeg",
  location: "Pittsburgh, PA, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 1922,
  isTopShop: true,
  isInsider: true,
  description:
    "Thank you for choosing Grandpa Joe's Candy Shop.  We distribute candy, craft soda, and snacks nationally from our Pittsburgh, PA distribution center.  You'll love our competitive pricing, amazing selection, and incredible customer service.  Our customers rave about our incredibly fast order fulfillment and minimal out of stock percentage.  \n\nIt all began for us in a 900sq ft store in Pittsburgh in just 2012.  We're a small business too.  We've grown quite a bit over the years, but one thing is for sure: we appreciate you!  Our founder/owner still pulls and packs orders, he's not afraid to answer the customer service phone, and he's in the building from sun up to sun down almost every single day.  We're honored to earn your business and so thankful you're choosing Grandpa Joe's.  Please don't hesitate to reach out to any member of our team.  We look forward to working with you!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:03.321Z",
    importedBy: "entity-db-cli",
  },
};
